import { Component, computed, effect, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
    IceDashboarPeriodPickerOptionsToValueMap,
    IceDashboardPeriodPickerEnum,
} from 'dashboard/enums/visuals/ice-dashboard-period-picker.enum';

@Component({
    selector: 'app-visuals-dashboard-period-picker',
    imports: [ReactiveFormsModule, TranslateModule],
    templateUrl: './visuals-dashboard-period-picker.component.html',
    styleUrl: './visuals-dashboard-period-picker.component.scss',
    host: {
        '(click)': '$event.stopPropagation()',
    },
})
export class VisualsDashboardPeriodPickerComponent {
    selectedOptionValue = input.required<number | null>();
    showLabel = input<boolean>(true);

    periodPickerForm = new FormGroup({
        periodControl: new FormControl<number | null>(null),
    });

    filterOptions = computed<{ label: string; value: number }[]>(() => {
        const options = IceDashboardPeriodPickerEnum;
        const values = Object.values(options);
        return values.map((option) => ({
            label: `dashboard.visuals.components.periodPicker.options.${option}`,
            value: IceDashboarPeriodPickerOptionsToValueMap[option],
        }));
    });

    formControlValue = toSignal(this.periodPickerForm.get('periodControl')!.valueChanges, { initialValue: null });

    periodChange = output<number | null>();

    constructor() {
        effect(() => {
            const selectedOptionValue = this.selectedOptionValue();
            if (selectedOptionValue !== null) {
                this.periodPickerForm.get('periodControl')?.setValue(selectedOptionValue);
            }
        });
        effect(() => {
            const formControlValue = this.formControlValue();
            this.periodChange.emit(formControlValue);
        });
    }
}
